import { Image, StyleSheet, Text, View } from "@react-pdf/renderer";
import React, { useEffect, useState } from "react";

const RaiseInvoicePdfHeaderView = (props) => {
  const { receiptPdfData } = props;

  const styles = StyleSheet.create({
    invoiceHeaderContainer: {
      borderBottom: "1px solid #E1E1E1",
      padding: "11px 22px",
    },
    invoiceHeader: {
      display: "flex",
      flexDirection: "row",
      width: "100%",
    },
    invoiceLeftHeader: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      width: "70%",
    },
    invoiceHeaderLogo: {
      width: "45px",
      height: "45px",
      marginRight: "10px",
    },
    invoiceRightHeader: {
      width: "30%",
    },
    invoiceHeaderClinicName: {
      color: "#171717",
      fontFamily: "notosans",
      fontSize: "10px",
      fontWeight: "600",
    },
    invoiceHeaderClinicAddress: {
      marginTop: "4px",
      color: "#1D1D1D",
      fontFamily: "notosans",
      fontSize: "7px",
      fontWeight: "normal",
    },
    invoiceRightHeaderContainer: {
      marginTop: "5px",
      display: "flex",
      flexDirection: "row",
    },
    invoiceRightHeaderTitle: {
      color: "#1D1D1D",
      fontFamily: "notosans",
      fontSize: "7px",
      fontWeight: "normal",
      marginRight: "5px",
      width: "27%",
    },
    invoiceRightHeaderValue: {
      color: "#1D1D1D",
      fontFamily: "notosans",
      fontSize: "7px",
      fontWeight: "500",
      overflowWrap: "anywhere",
    },
    invoiceHeaderClinicDetails: {
      width: "80%",
    },
    invoiceRightHeaderValueContainer: {
      width: "70%",
    },
  });

  const [receiptHeaderData, setReceiptHeaderData] = useState({});

  // Lifecycle Methods ===>

  useEffect(() => {
    if (Object?.keys(receiptPdfData)?.length > 0) {
      setReceiptHeaderData({ ...receiptPdfData?.payload_reciept });
    }
  }, [receiptPdfData]);

  // <===

  const displayReceiptHeaderView = () => {
    return (
      <View style={styles.invoiceHeader}>
        <View style={styles.invoiceLeftHeader}>
          {receiptHeaderData?.HEADER_HOSPITAL_DATA?.is_hospital_logo_enabled &&
            receiptHeaderData?.HEADER_HOSPITAL_DATA?.hospital_logo_path !==
              "" && (
              <Image
                style={styles.invoiceHeaderLogo}
                src={
                  receiptHeaderData?.HEADER_HOSPITAL_DATA?.hospital_logo_path
                }
                alt=""
              />
            )}

          <View style={styles.invoiceHeaderClinicDetails}>
            <Text style={styles.invoiceHeaderClinicName}>
              {receiptHeaderData?.HEADER_HOSPITAL_DATA?.hospital_name}
            </Text>
            <Text style={styles.invoiceHeaderClinicAddress}>
              {receiptHeaderData?.HEADER_HOSPITAL_DATA?.clinic_address}
            </Text>
          </View>
        </View>
        <View style={styles.invoiceRightHeader}>
          <View style={styles.invoiceRightHeaderContainer}>
            <Text style={styles.invoiceRightHeaderTitle}>Receipt No</Text>
            <View style={styles.invoiceRightHeaderValueContainer}>
              <Text style={styles.invoiceRightHeaderValue}>
                {receiptHeaderData?.RECIEPT_NO}
              </Text>
            </View>
          </View>
          <View style={styles.invoiceRightHeaderContainer}>
            <Text style={styles.invoiceRightHeaderTitle}>Receipt Date</Text>
            <View style={styles.invoiceRightHeaderValueContainer}>
              <Text style={styles.invoiceRightHeaderValue}>
                {receiptHeaderData?.INVOICE_DATE === ""
                  ? "-"
                  : receiptHeaderData?.INVOICE_DATE}
              </Text>
            </View>
          </View>
          {receiptHeaderData?.formatted_uhid !== "" && (
            <View style={styles.invoiceRightHeaderContainer}>
              <Text style={styles.invoiceRightHeaderTitle}>UHID</Text>
              <View style={styles.invoiceRightHeaderValueContainer}>
                <Text style={styles.invoiceRightHeaderValue}>
                  {receiptHeaderData?.formatted_uhid === ""
                    ? "-"
                    : receiptHeaderData?.formatted_uhid?.split("")}
                </Text>
              </View>
            </View>
          )}
        </View>
      </View>
    );
  };

  return (
    <View style={styles.invoiceHeaderContainer}>
      {Object?.keys(receiptHeaderData)?.length > 0
        ? !receiptHeaderData?.custom_margins_enabled &&
          receiptHeaderData?.HEADER_HOSPITAL_DATA !== null &&
          receiptHeaderData?.HEADER_HOSPITAL_DATA !== undefined &&
          displayReceiptHeaderView()
        : null}
    </View>
  );
};

export default RaiseInvoicePdfHeaderView;
